import { createPublicClient, http } from 'viem'
import { sepolia } from 'viem/chains'
import Web3 from 'web3'

export const publicClient = createPublicClient({
    chain: sepolia,
    transport: http()
})

const PROVIDER_URL_BSC = process.env.REACT_APP_PROVIDER_URL_BSC || 'https://bsc-dataseed.binance.org/';
const PROVIDER_URL_SEP = process.env.REACT_APP_PROVIDER_URL_SEP || 'https://rpc.sepolia.org';
const PROVIDER_URL_BASE = process.env.REACT_APP_PROVIDER_URL_BASE || 'https://mainnet.base.org';
const PROVIDER_URL_POL = process.env.REACT_APP_PROVIDER_URL_POL || 'https://polygon-rpc.com/';
const PROVIDER_URL_ETH = process.env.REACT_APP_PROVIDER_URL_ETH || 'https://mainnet.infura.io/v3/YOUR_INFURA_ID'; // Replace with your Infura ID or provider
const PROVIDER_URL_TAO = 'https://rpc.taoevm.io'
const PROVIDER_URL_BSCTEST = 'https://bsc-testnet.public.blastapi.io'

export const web3ClientBsc = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_BSC))
export const web3ClientSep = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_SEP))
export const web3Client = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_ETH))
export const baseWeb3Client = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_BASE))
export const polWeb3Client = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_POL))
export const taoWeb3Client = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_TAO))
export const web3ClientBscTest = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_BSCTEST))

export const web3Clients = {
    56: web3ClientBsc,
    11155111: web3ClientSep,
    1: web3Client,
    137: polWeb3Client,
    8453: baseWeb3Client,
    10321: taoWeb3Client,
    97: web3ClientBscTest

}

export const apiUrl = process.env.REACT_APP_API_URL || 'https://testproyect100new.online:9001';

// --- Derive WebSocket URL from apiUrl ---
// Replace http/https with ws/wss
const wsProtocol = apiUrl.startsWith('https') ? 'wss' : 'ws';
const httpUrl = apiUrl.replace(/^https?:\/\//, '');
export const chatWsUrl = `${wsProtocol}://${httpUrl}`; // Should result in wss://testproyect100new.online:9001

export const livekitWsUrl = process.env.REACT_APP_LIVEKIT_WS_URL || "wss://testproyect100new.online:9001"; // Keep this if used for LiveKit video

export const imageUrl = apiUrl + '/token/'

export const projectName = "PumpItUpTest"

export const zeroAddress = "0x0000000000000000000000000000000000000000"

export const adminAddress = "0x11F538A35A6D33849534577ab2B2e8c6E261E88f";

export const volumeBotFeeAddress = "0x11F538A35A6D33849534577ab2B2e8c6E261E88f"; // Added fee address

// Cambiar esto:
//export const BASE_URL = 'http://localhost:3000';


// Por esto (usando detección automática):
export const BASE_URL = window.location.origin;
{/* 
export const ethPriceApiUrl = {
    1: 'https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD',
    56: 'https://min-api.cryptocompare.com/data/price?fsym=BNB&tsyms=USD',
    11155111: 'https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD',
    8453: 'https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD',
    137: 'https://min-api.cryptocompare.com/data/price?fsym=POL&tsyms=USD',
    10321: 'https://min-api.cryptocompare.com/data/price?fsym=TAO&tsyms=USD',
    97: 'https://min-api.cryptocompare.com/data/price?fsym=BNB&tsyms=USD'
}
*/}
// export const supportedChainIds = [mainnet.id, bsc.id, base.id, 10321]
export const supportedChainIds = [97]

export const chainLogos = {
    1: '/eth.svg',
    56: '/bsc.svg',
    11155111: '/eth.svg',
    137: '/polygon.svg',
    8453: '/base.svg',
    10321: '/tao.png',
    97: '/bsc.svg',
}

export const feeAmounts = {
    1: 0,
    8453: 0,
    56: 0.005,
    137: 7.13,
    11155111: 0,
    10321: 0.0012,
    97: 0.001,
}

export const initialEth1 = {
    1: 1.5698,
    8453: 1.5698,
    56: 8.48,
    137: 12558,
    11155111: 1.9,
    10321: 1.9,
    97: 8.53125
}

export const initialEth2 = {
    1: 1.5698,
    8453: 1.5698,
    56: 8.48,
    137: 12558,
    11155111: 1.9,
    10321: 1.9,
    97: 6.2039
}

export const coinNames = {
    ETH8453: 'ETH',
    56: 'BNB',
    11155111: 'ETH',
    10: 'ETH',
    137: 'POL',
    10321: 'TAO',
    97: 'BNB',
}

export const scanLinks = {
    8453: 'https://basescan.org/',
    1: 'https://etherscan.io/',
    56: 'https://bscscan.com/',
    11155111: 'https://sepolia.etherscan.io/',
    137: 'https://polygonscan.com/',
    10: 'https://optimistic.etherscan.io/',
    10321: 'https://taoscan.org/',
    97: 'https://testnet.bscscan.com/',
}

export const scanApiLinks = {
    8453: 'https://api.basescan.org/api',
    1: 'https://api.etherscan.io/api',
    56: 'https://api.bscscan.com/api',
    11155111: 'https://api-sepolia.etherscan.io/api',
    137: 'https://api.polygonscan.com/api',
    10321: 'https://taoscan.org/api',
    97: 'https://api-testnet.bscscan.com/api'
}

export const apiKeys = {
    56: 'BX6Y1N1V6SSS4MVGB7SN6IRKQX2JTIXSDN',
    1: '2E446YFS6EPUCJQ84W6GHX626759K121NP',
    11155111: '2E446YFS6EPUCJQ84W6GHX626759K121NP',
    8453: '26VQ3BGAUVDCN9VCNP7PZNG47I8X3S82F2',
    97: 'BX6Y1N1V6SSS4MVGB7SN6IRKQX2JTIXSDN',
}

export const chainNames = {
    1: 'eth',
    11155111: 'eth',
    8453: 'base',
    56: 'bnb',
    137: 'polygon',
    10321: 'tao',
    97: 'bnb',
}

export const chainNames1 = {
    1: 'ethereum',
    11155111: 'ethereum',
    8453: 'base',
    56: 'bsc',
    137: 'polygon',
    10321: 'tao',
    97: 'bsc',
}

const formatNumber = (num) => {
  if (num === undefined || num === null) return '0';
  if (num >= 1e9) {
    return (num / 1e9).toFixed(2) + 'B';
  } else if (num >= 1e6) {
    return (num / 1e6).toFixed(2) + 'M';
  } else if (num >= 1e3) {
    return (num / 1e3).toFixed(2) + 'K';
  } else {
    // For smaller numbers, decide if you want decimals or not
    // Option 1: Show decimals for numbers less than 1000
    // return num.toFixed(2);
    // Option 2: Show integers for numbers less than 1000, maybe decimals for very small numbers
     return num < 1 ? num.toFixed(4) : num.toFixed(0);
    // Option 3: Use toLocaleString for automatic formatting based on locale
    // return num.toLocaleString(undefined, { maximumFractionDigits: 0 }); // No decimals for numbers < 1000
  }
};

export default formatNumber; // Or export { formatNumber }; depending on your setup